import type { PolicyEntity } from '@/shared/entities/PolicyEntity'

export class RoleEntity {
  id?: number
  name?: string | null
  policies?: Array<PolicyEntity> | null
  createdAt?: string | null
}
